import { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import Iconify from 'src/components/iconify';

import FaqsHero from '../faqs-hero';
import FaqsList from '../faqs-list';
import FaqsForm from '../faqs-form';
import FaqsCategory from '../faqs-category';
import type { FaqCategoryId } from '../faqs-data';

// ----------------------------------------------------------------------

export default function FaqsView() {
  const [activeCategory, setActiveCategory] = useState<FaqCategoryId | null>(null);

  return (
    <>
      <FaqsHero />

      <Container
        sx={{
          pb: 10,
          pt: { xs: 10, md: 15 },
          position: 'relative',
        }}
      >
        <FaqsCategory active={activeCategory} onSelect={setActiveCategory} />

        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ my: { xs: 5, md: 10 } }}
        >
          <Typography variant="h3">Frequently asked questions</Typography>
          {activeCategory && (
            <Button
              variant="outlined"
              size="small"
              onClick={() => setActiveCategory(null)}
              startIcon={<Iconify icon="eva:close-fill" />}
            >
              Show all
            </Button>
          )}
        </Stack>

        <Box
          gap={10}
          display="grid"
          gridTemplateColumns={{
            xs: 'repeat(1, 1fr)',
            md: 'repeat(2, 1fr)',
          }}
        >
          <FaqsList activeCategory={activeCategory} />

          <FaqsForm />
        </Box>
      </Container>
    </>
  );
}
